import { ClinicConfig, EInvoiceConfig, InboundApiConfig, MedicalFacilityConfigRequest, PrescriptionAPIConfig } from '../../types';
import { delay } from '../mock/delay';
import { mockClinicConfig, mockPrescriptionAPIConfig } from '../mock/config';
import { AxiosResponse } from 'axios';
import apiClient from '../api/client';

export const configService = {
  getClinicConfig: async (): Promise<ClinicConfig> => {
    await delay(300);
    return mockClinicConfig;
  },

  saveMedicalFacilityConfig: async (config: MedicalFacilityConfigRequest): Promise<AxiosResponse<any>> => {
    return apiClient.put<MedicalFacilityConfigRequest, AxiosResponse>('/medical-facilities/config/national-rx/', config);
  },

  saveEInvoiceConfig: async (config: EInvoiceConfig): Promise<AxiosResponse<any>> => {
    return apiClient.put<EInvoiceConfig, AxiosResponse>('/medical-facilities/config/einvoice/', config);
  },

  getPrescriptionAPIConfig: async (): Promise<PrescriptionAPIConfig> => {
    await delay(300);
    return mockPrescriptionAPIConfig;
  },

  getMedicalFacilityConfig: async (): Promise<AxiosResponse<{success: boolean, data: MedicalFacilityConfigRequest}>> => {
    return apiClient.get('/medical-facilities/config/national-rx/');
  },

  getEInvoiceConfig: async (type: 'pharmacy' | 'medical_facility'): Promise<AxiosResponse<{success: boolean, data: EInvoiceConfig}>> => {
    return apiClient.get('/medical-facilities/config/einvoice/?type=' + type);
  },

  // Admin: config by medical_facility_id
  getAdminNationalRxConfig: async (medicalFacilityId: number): Promise<AxiosResponse<{ success: boolean; data: MedicalFacilityConfigRequest }>> => {
    return apiClient.get(`/admin/medical-facilities/${medicalFacilityId}/config/national-rx/`);
  },

  saveAdminNationalRxConfig: async (medicalFacilityId: number, config: Omit<MedicalFacilityConfigRequest, 'medical_facility'>): Promise<AxiosResponse<any>> => {
    return apiClient.put(`/admin/medical-facilities/${medicalFacilityId}/config/national-rx/`, {
      ...config,
      medical_facility: medicalFacilityId,
    });
  },

  getAdminEInvoiceConfig: async (medicalFacilityId: number, type: 'medical_facility' | 'pharmacy'): Promise<AxiosResponse<{ success: boolean; data: EInvoiceConfig }>> => {
    return apiClient.get(`/admin/medical-facilities/${medicalFacilityId}/config/einvoice/?type=${type}`);
  },

  saveAdminEInvoiceConfig: async (medicalFacilityId: number, config: EInvoiceConfig): Promise<AxiosResponse<any>> => {
    return apiClient.put(`/admin/medical-facilities/${medicalFacilityId}/config/einvoice/`, config);
  },

  getAdminInboundApiConfig: async (medicalFacilityId: number): Promise<AxiosResponse<{ success: boolean; data: InboundApiConfig }>> => {
    return apiClient.get(`/admin/medical-facilities/${medicalFacilityId}/config/inbound-api/`);
  },

  saveAdminInboundApiConfig: async (medicalFacilityId: number, config: InboundApiConfig): Promise<AxiosResponse<any>> => {
    return apiClient.put(`/admin/medical-facilities/${medicalFacilityId}/config/inbound-api/`, config);
  },

  getInboundApiConfig: async (): Promise<AxiosResponse<{ success: boolean; data: InboundApiConfig }>> => {
    return apiClient.get('/medical-facilities/config/inbound-api/');
  },

  downloadManualConnectPartner: async (): Promise<Blob> => {
    const response = await apiClient.get('/documents/manual-connect-partner/', {
      responseType: 'blob',
    });
    return response.data;
  },

  saveInboundApiConfig: async (config: InboundApiConfig): Promise<AxiosResponse<any>> => {
    return apiClient.put('/medical-facilities/config/inbound-api/', config);
  },

  savePrescriptionAPIConfig: async (config: PrescriptionAPIConfig): Promise<void> => {
    await delay(800);
    Object.assign(mockPrescriptionAPIConfig, config);
  },

  // post for media files
  uploadFile: async (file: File): Promise<AxiosResponse<any>> => {
    return apiClient.postForm('/mediafiles/', {
      file: file,
      file_type: "image"
    });
  },
};

